<template>
    <v-overlay :value="value" z-index="1000">
        <v-alert>
            <v-icon x-large >mdi-email-fast-outline</v-icon>
            <v-progress-linear
                indeterminate
                color="cyan"
            ></v-progress-linear>
        </v-alert>
    </v-overlay>
</template>
<script>
    export default {
        name: "LoadingSendingMail",
        props: {
            value: Boolean,
        },
    }
</script>